import { render, staticRenderFns } from "./BlockDadataWithIcon.vue?vue&type=template&id=b564116e&scoped=true&"
import script from "./BlockDadataWithIcon.vue?vue&type=script&lang=ts&"
export * from "./BlockDadataWithIcon.vue?vue&type=script&lang=ts&"
import style0 from "./BlockDadataWithIcon.vue?vue&type=style&index=0&id=b564116e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b564116e",
  null
  
)

export default component.exports